
/**
 * Fix Cart Count Persistence
 * Forces the cart count to update from the server on page load.
 * This fixes the issue where the cart count shows 0 on navigation until an item is added.
 */
(function ($) {
    $(window).on('load', function () {
        if (typeof ShowCart === 'function') {
            ShowCart();
        }
    });
})(jQuery);
